(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/onboarding/image-helpers/assets/javascripts/image-context.js') >= 0) return;  svs.modules.push('/components/onboarding/image-helpers/assets/javascripts/image-context.js');
"use strict";

const _React = React,
  createContext = _React.createContext;

const ImageContextInitState = {};
const ImageContext = createContext(ImageContextInitState);
setGlobal('svs.components.onboarding.imageHelpers.ImageContext', ImageContext);

 })(window);